import { IRequestOptions, IResponseResult } from 'models/api.model'
import { RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class GoogleSheetsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  post(formData: FormData): Promise<IResponseResult<Response>> {
    // Prod 'script.google.com/macros/s/AKfycbwu6-oz7zLOdM5VPWOBOembAvCsyA-5lwgT99AMzbP1cz6FyVm56oCjRIHCWXG0btM/exec'
    // Only dev used
    const url =
      'script.google.com/macros/s/AKfycbwdxHqvOFBm7ExbYxR-GHw6tIgl3YdpEKUA5IqVBB5ZB2hJOt4j4PCaae8sLGz4bImq/exec'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      mode: 'no-cors',
      body: formData,
    }

    return this.api.makeCustomRequest<IResponseResult<Response>>(url, options)
  }

  postInvoxia(formData: FormData): Promise<IResponseResult<Response>> {
    const url =
      import.meta.env.CURRENT_ENV === 'prod'
        ? 'script.google.com/macros/s/AKfycbwk3G3nzSDHRUjPeWu4wPLDAb4NQMVTQHIBvTuQW5FL_Od_RcCqCq3Li5yAbeQlBOcQ/exec'
        : 'script.google.com/macros/s/AKfycbzNvNJPRcCIhsxDTcUoEgUmUIRBaQb213wOQbWLbHg_wuBCBgPI8A4POtXT-T5MU2-xhg/exec'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      mode: 'no-cors',
      body: formData,
    }

    return this.api.makeCustomRequest<IResponseResult<Response>>(url, options)
  }

  postVc3Cohort(formData: FormData): Promise<IResponseResult<Response>> {
    const url =
      'script.google.com/macros/s/AKfycbwdxHqvOFBm7ExbYxR-GHw6tIgl3YdpEKUA5IqVBB5ZB2hJOt4j4PCaae8sLGz4bImq/exec'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      mode: 'no-cors',
      body: formData,
    }

    return this.api.makeCustomRequest<IResponseResult<Response>>(url, options)
  }

  postVc6Cohort(formData: FormData): Promise<IResponseResult<Response>> {
    // 'script.google.com/macros/s/AKfycbyY0X0bq_mil_oV6Py2JCnOo-l0d4OUKM8yCGjjl4RuuHcNBYMiG5ulckS4rGe3Bt4C/exec'
    const url =
      'script.google.com/macros/s/AKfycbzrmERRByYZDo4shB1iaL8KnyZ4O6fNwH4gJy0_9wA03JVWLoZjVhQBzezNTgHZ6a1R/exec'

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      mode: 'no-cors',
      body: formData,
    }

    return this.api.makeCustomRequest<IResponseResult<Response>>(url, options)
  }
}
